import { ErrorInterface } from '../../interfaces/general.interface';

export interface ChangePasswordState {
  error: boolean | ErrorInterface;
  loading: boolean;
  response: boolean | null;
}

export const initialChangePasswordState: ChangePasswordState = {
  error: false,
  loading: false,
  response: null,
};
